import './noBannerDataError.scss';

import React from 'react';

import { i18n } from 'core/i18n';
const { formatText, FormattedText } = i18n;
import classNames from 'classnames';
import { OKButton } from 'components/commons/OKButton/OKButton';
import { LoadingSection } from 'commonsComponents/loadingSection'

function NoBannerDataError({ primaryText, secondaryText, errorTertiaryText, onClick, buttonText, isLoading }) {
    const containerClassName = classNames('no-banner-data-error', {
        'no-banner-data-error--loading': isLoading,
    });

    let content;
    if (isLoading) {
        content = <LoadingSection />
    } else {
        content = (
            <>
                <div className='no-banner-data-error__item'>
                    <i className="no-banner-data-error__logo icon empty-state-noitems-banking" />
                </div>
                <div className='no-banner-data-error__item no-banner-data-error__title'><FormattedText value={primaryText} /></div>
                <div className='no-banner-data-error__item'><FormattedText value={secondaryText} /></div>
                <div className='no-banner-data-error__item'>
                    <OKButton modifier="secondary" onClick={onClick}>{formatText(buttonText)}</OKButton>
                </div>
                <div><FormattedText value={errorTertiaryText} /></div>
            </>
        );
    }

    return (
        <div className={containerClassName}>
            {content}
        </div>
    )
}

export default NoBannerDataError;